import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { authService } from '../../services/auth';
import './UserDashboard.css';

const DashboardLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const user = authService.getCurrentUser();
  const [open, setOpen] = useState(true);

  return (
    <div className={`dash-shell ${open ? 'sidebar-open' : 'sidebar-collapsed'}`}>
      <header className="dash-topbar">
        <button className="icon-btn" onClick={() => setOpen(v => !v)} aria-label="Toggle sidebar">
          <i className="fas fa-bars"></i>
        </button>
        <div className="brand">
          <Link to="/dashboard">Shopnonagar</Link>
        </div>
        <div className="top-actions">
          <Link to="/notices" className="link"><i className="fas fa-bullhorn"></i> Notices</Link>
          <Link to="/profile" className="link"><i className="fas fa-user"></i> Profile</Link>
        </div>
      </header>

      <aside className="dash-sidebar">
        <div className="user-panel">
          <div className="avatar">
            <i className="fas fa-user"></i>
          </div>
          <div className="meta">
            <div className="welcome">Welcome</div>
            <div className="name">{user?.name || ''}</div>
            {user?.role && <div className="role">{(user.role || '').replace('_', ' ')}</div>}
          </div>
        </div>
        <nav className="menu">
          <Link to="/dashboard" className="menu-item"><i className="fas fa-th-large"></i><span>Dashboard</span></Link>
          <Link to="/resident" className="menu-item"><i className="fas fa-home"></i><span>My Residence</span></Link>
          <a href="/dashboard#flat-members" className="menu-item"><i className="fas fa-users"></i><span>People in Flat</span></a>
          <a href="/dashboard#flat-users" className="menu-item"><i className="fas fa-user-friends"></i><span>Registered Users</span></a>
          <Link to="/profile" className="menu-item"><i className="fas fa-id-card"></i><span>My Profile</span></Link>
          <Link to="/notices" className="menu-item"><i className="fas fa-bell"></i><span>Notices</span></Link>
          {(user?.role === 'manager' || user?.role === 'building_committee') && (
            <Link to="/manager" className="menu-item"><i className="fas fa-users-cog"></i><span>Manager</span></Link>
          )}
          {(user?.role === 'admin' || user?.role === 'central_committee') && (
            <Link to="/admin" className="menu-item"><i className="fas fa-cogs"></i><span>Admin</span></Link>
          )}
        </nav>
      </aside>

      <main className="dash-main">
        {children ? children : <Outlet />}
      </main>
    </div>
  );
};

export default DashboardLayout;


